import React from 'react';
import { Link } from 'react-router-dom';
import { 
  Heart, 
  Cpu, 
  ArrowUpRight,
  Sparkles,
  Zap,
  Globe
} from 'lucide-react';
import logo from '../logo.png';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const handleScrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer style={{
      background: 'rgba(255, 255, 255, 0.9)',
      backdropFilter: 'blur(16px)',
      borderTop: '1px solid var(--border-color)',
      padding: '70px 24px 32px 24px',
      marginTop: 'auto',
      position: 'relative'
    }}>
      {/* Background soft glow effects */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: '10%',
        width: '300px',
        height: '300px',
        background: 'radial-gradient(circle, rgba(5, 117, 251, 0.04) 0%, transparent 70%)',
        zIndex: -1,
        pointerEvents: 'none'
      }} />
      <div style={{
        position: 'absolute',
        bottom: 0,
        right: '10%',
        width: '350px',
        height: '350px',
        background: 'radial-gradient(circle, rgba(14, 165, 233, 0.04) 0%, transparent 70%)',
        zIndex: -1,
        pointerEvents: 'none'
      }} />

      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
        gap: '48px',
        marginBottom: '56px'
      }}>
        {/* Column 1: Brand details & bio */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
          <Link to="/" style={{ display: 'inline-flex', alignItems: 'center' }} onClick={handleScrollToTop}>
            <img 
              src={logo} 
              alt="Toolmetrico Logo"
              width="30"
              height="30"
              style={{ height: '30px', width: 'auto', objectFit: 'contain' }} 
            />
          </Link>
          <p style={{
            fontSize: '0.88rem',
            color: 'var(--text-secondary)',
            lineHeight: 1.65,
            maxWidth: '280px'
          }}>
            Explore premium, open-source web utility tools designed to optimize productivity, boost search marketing, and scale developer workflows.
          </p>
        </div>

        {/* Column 2: Navigation Directory */}
        <div>
          <h4 style={{
            fontSize: '0.78rem',
            fontWeight: 700,
            textTransform: 'uppercase',
            letterSpacing: '0.08em',
            color: 'var(--text-primary)',
            marginBottom: '20px',
            display: 'flex',
            alignItems: 'center',
            gap: '6px'
          }}>
            <Globe size={14} style={{ color: 'var(--primary)' }} /> Navigation
          </h4>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <Link to="/" className="footer-link" onClick={handleScrollToTop}>Home Directory</Link>
            <Link to="/about" className="footer-link" onClick={handleScrollToTop}>About Us</Link>
            <Link to="/blog" className="footer-link" onClick={handleScrollToTop}>Editorial Blog</Link>
            <Link to="/contact" className="footer-link" onClick={handleScrollToTop}>Contact Us</Link>
            <Link to="/privacy" className="footer-link" onClick={handleScrollToTop}>Privacy Policy</Link>
            <Link to="/terms" className="footer-link" onClick={handleScrollToTop}>Terms & Conditions</Link>
          </div>
        </div>

        {/* Column 3: Resource Topics / Custom Static tools categories requested */}
        <div>
          <h4 style={{
            fontSize: '0.78rem',
            fontWeight: 700,
            textTransform: 'uppercase',
            letterSpacing: '0.08em',
            color: 'var(--text-primary)',
            marginBottom: '20px',
            display: 'flex',
            alignItems: 'center',
            gap: '6px'
          }}>
            <Zap size={14} style={{ color: 'var(--secondary)' }} /> Tool Hubs
          </h4>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <Link 
              to="/?category=QR %26 Generator Tools" 
              className="footer-link" 
              onClick={handleScrollToTop}
              style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}
            >
              <span>QR & Generator Tools</span>
              <ArrowUpRight size={12} className="footer-link-arrow" style={{ opacity: 0, transition: 'var(--transition-smooth)' }} />
            </Link>
            <Link 
              to="/?category=Image Tools" 
              className="footer-link" 
              onClick={handleScrollToTop}
              style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}
            >
              <span>Image Compress & Convert</span>
              <ArrowUpRight size={12} className="footer-link-arrow" style={{ opacity: 0, transition: 'var(--transition-smooth)' }} />
            </Link>
            <Link 
              to="/?category=PDF Tools" 
              className="footer-link" 
              onClick={handleScrollToTop}
              style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}
            >
              <span>PDF & Office Utilities</span>
              <ArrowUpRight size={12} className="footer-link-arrow" style={{ opacity: 0, transition: 'var(--transition-smooth)' }} />
            </Link>
            <Link 
              to="/?category=YouTube Tools" 
              className="footer-link" 
              onClick={handleScrollToTop}
              style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', color: '#ef4444' }}
            >
              <span>YouTube Optimization Suite</span>
              <ArrowUpRight size={12} className="footer-link-arrow" style={{ opacity: 0, transition: 'var(--transition-smooth)' }} />
            </Link>
          </div>
        </div>

        {/* Column 4: High Premium developer mission card */}
        <div>
          <h4 style={{
            fontSize: '0.78rem',
            fontWeight: 700,
            textTransform: 'uppercase',
            letterSpacing: '0.08em',
            color: 'var(--text-primary)',
            marginBottom: '20px',
            display: 'flex',
            alignItems: 'center',
            gap: '6px'
          }}>
            <Sparkles size={14} style={{ color: '#eab308' }} /> Performance Pledge
          </h4>
          <p style={{
            fontSize: '0.88rem',
            color: 'var(--text-secondary)',
            lineHeight: 1.6,
            marginBottom: '16px'
          }}>
            Optimizing browser-native software systems. Free utilities, zero tracking cookies, premium execution.
          </p>
          <div style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            background: 'rgba(5, 117, 251, 0.05)',
            border: '1px solid rgba(5, 117, 251, 0.1)',
            padding: '6px 12px',
            borderRadius: '8px',
            fontSize: '0.78rem',
            color: 'var(--primary)',
            fontWeight: 700
          }}>
            <Cpu size={14} />
            <span>100% Client-Side Engine</span>
          </div>
        </div>
      </div>

      <hr style={{ border: 'none', borderTop: '1px solid var(--border-color)', marginBottom: '24px' }} />

      {/* Bottom Legal, Back to Top & Credits info */}
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '20px',
        fontSize: '0.825rem',
        color: 'var(--text-muted)'
      }}>
        <span>&copy; {currentYear} Toolmetrico. All developer rights reserved.</span>
        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
          <span>Crafted with</span>
          <Heart size={12} style={{ color: '#ef4444', fill: '#ef4444' }} />
          <span>for a faster, lighter web ecosystem.</span>
        </div>
      </div>

      {/* Premium Embedded Styles for Footer link and social interaction overlays */}
      <style>{`
        .footer-link {
          font-size: 0.88rem;
          color: var(--text-secondary);
          text-decoration: none;
          transition: var(--transition-smooth);
        }
        
        .footer-link:hover {
          color: var(--primary) !important;
          transform: translateX(4px);
        }

        .footer-link:hover .footer-link-arrow {
          opacity: 1 !important;
          transform: translateX(2px) translateY(-2px);
        }
        
        .footer-social-link:hover {
          color: var(--primary) !important;
          background-color: rgba(5, 117, 251, 0.08) !important;
          transform: translateY(-2px);
        }
      `}</style>
    </footer>
  );
};

export default Footer;
